import { apiGet, apiPut, API_URI, apiDelete } from 'api';

const notifications = {
    getAll: async () => {
        const data = await apiGet(`${API_URI}/api/notification/get/contact`);
        return data;
    },
    seen: async (notificationIds: number[]) => {
        await apiPut(`${API_URI}/api/notification/seen`, notificationIds);
    },
    delete: async (id: number) => {
        await apiDelete(`${API_URI}/api/notification/delete?id=${id}`);
    }
}

export default notifications;